module.exports = __webpack_public_path__ + "img/Pop-up_02_Ideology.dfe01b0c.png";